import type { CasingsQueryVariables, Casings_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restoreCasings(arr: Array<string>): Casings_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteCasings(arr: Array<string>): Casings_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultCasingVars: CasingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }]
};

export const adminCasingVars: CasingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }]
};

export const kocCasingVars: CasingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolCasingVars: CasingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
